// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
//   CircularProgress, Select, MenuItem, FormControl, InputLabel,
// } from '@mui/material';
// import { Delete, Edit } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { API_BASE_URL } from '../../config';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import api from '../../api/axiosInterceptor';
// import axios from 'axios';

// export const AdminLegalTeamComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [categories, setCategories] = useState(['All']);
//   const [categoryFilter, setCategoryFilter] = useState('All');

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedMember, setSelectedMember] = useState(null);

//   const [formData, setFormData] = useState({
//     name: '',
//     designation: '',
//     qualification: '',
//     roles_and_responsibility: '',
//     appointment_date: '',
//     renewal_date: '',
//     catogary: '',
//     rank: 0,
//     photo: null,
//     link: '',
//   });

//   const [formErrors, setFormErrors] = useState({});
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteMember, setDeleteMember] = useState(null);

//   const [submitting, setSubmitting] = useState(false);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'name', field: 'name', headerName: 'Name', width: 150 },
//     { id: 'designation', field: 'designation', headerName: 'Designation', width: 150 },
//     { id: 'qualification', field: 'qualification', headerName: 'Qualification', width: 150 },
//     { id: 'roles', field: 'roles', headerName: 'Roles & Responsibility', width: 250 },
//     {
//       id: 'appointment_date',
//       field: 'appointment_date',
//       headerName: 'Appointment Date',
//       width: 150,
//       renderCell: (params) => (params.value ? new Date(params.value).toLocaleDateString() : ''),
//     },
//     {
//       id: 'renewal_date',
//       field: 'renewal_date',
//       headerName: 'Renewal Date',
//       width: 150,
//       renderCell: (params) => (params.value ? new Date(params.value).toLocaleDateString() : ''),
//     },
//     { id: 'catogary', field: 'catogary', headerName: 'Category', width: 150 },
//     { id: 'rank', field: 'rank', headerName: 'Rank', width: 90 },
//     {
//       id: 'photo',
//       field: 'photo',
//       headerName: 'Photo',
//       width: 100,
//       renderCell: (params) =>
//         params.value ? (
//           <img src={params.value} alt="team" style={{ width: 50, height: 50, borderRadius: '50%' }} />
//         ) : (
//           'N/A'
//         ),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={submitting}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={submitting}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     fetchLegalTeam(categoryFilter);
//   }, [categoryFilter]);

//   const fetchCategories = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/home-notification/legal-team/`);
//       const uniqueCategories = Array.from(
//         new Set(response.data.map((item) => item.catogary).filter((cat) => !!cat))
//       );
//       setCategories(['All', ...uniqueCategories]);
//     } catch (error) {
//       console.error('Failed to fetch categories:', error);
//       setSnackbarMessage('Failed to load categories.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       setCategories(['All']);
//     }
//   };

//   const fetchLegalTeam = (category) => {
//     setLoading(true);
//     let url = `${API_BASE_URL}/home-notification/legal-team/`;
//     if (category && category !== 'All') {
//       url += `?catogary=${encodeURIComponent(category)}`;
//     }
//     axios
//       .get(url)
//       .then((response) => {
//         const data = response.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           name: item.name,
//           designation: item.designation,
//           qualification: item.qualification,
//           roles: item.roles_and_responsibility,
//           appointment_date: item.appointment_date,
//           renewal_date: item.renewal_date,
//           catogary: item.catogary,
//           rank: item.rank,
//           photo: item.photo,
//           link: item.link,
//         }));
//         setRows(data);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch legal team data:', error);
//         setSnackbarMessage('Failed to load legal team data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleCategoryChange = (event) => {
//     setCategoryFilter(event.target.value);
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddMember = () => {
//     setIsEditMode(false);
//     setFormData({
//       name: '',
//       designation: '',
//       qualification: '',
//       roles_and_responsibility: '',
//       appointment_date: '',
//       renewal_date: '',
//       catogary: '',
//       rank: 0,
//       photo: null,
//       link: '',
//     });
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (member) => {
//     setIsEditMode(true);
//     setSelectedMember(member);
//     setFormData({
//       name: member.name,
//       designation: member.designation,
//       qualification: member.qualification,
//       roles_and_responsibility: member.roles,
//       appointment_date: member.appointment_date ? member.appointment_date.split('T')[0] : '',
//       renewal_date: member.renewal_date ? member.renewal_date.split('T')[0] : '',
//       catogary: member.catogary,
//       rank: member.rank,
//       photo: member.photo,
//       link: member.link || '',
//     });
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (member) => {
//     setDeleteMember(member);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(`${API_BASE_URL}/home-notification/legal-team/${deleteMember.id}/`)
//       .then(() => {
//         setSnackbarMessage('Team member deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchLegalTeam(categoryFilter);
//       })
//       .catch((error) => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete team member.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteMember(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.name?.trim()) errors.name = 'Name is required';
//     if (!formData.designation?.trim()) errors.designation = 'Designation is required';
//     if (!formData.qualification?.trim()) errors.qualification = 'Qualification is required';
//     if (!formData.roles_and_responsibility?.trim()) errors.roles_and_responsibility = 'Roles & Responsibility is required';
//     if (!formData.appointment_date) errors.appointment_date = 'Appointment Date is required';
//     if (!formData.renewal_date) errors.renewal_date = 'Renewal Date is required';
//     if (!formData.catogary?.trim()) errors.catogary = 'Category is required';
//     if (formData.rank === '' || isNaN(formData.rank)) errors.rank = 'Rank must be a number';
//     if (!formData.photo) {
//       errors.photo = 'Photo file is required';
//     } else if (typeof formData.photo === 'object' && formData.photo.size > 1024 * 1024) {
//       errors.photo = 'Photo must be less than 1 MB';
//     }
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     if (e.target.files && e.target.files.length > 0) {
//       setFormData({ ...formData, photo: e.target.files[0] });
//     }
//   };

//   const handleFormSubmit = () => {
//     if (!validateForm()) return;
//     setSubmitting(true);
//     const dataToSubmit = new FormData();
//     dataToSubmit.append('name', formData.name);
//     dataToSubmit.append('designation', formData.designation);
//     dataToSubmit.append('qualification', formData.qualification);
//     dataToSubmit.append('roles_and_responsibility', formData.roles_and_responsibility);
//     dataToSubmit.append('appointment_date', formData.appointment_date);
//     dataToSubmit.append('renewal_date', formData.renewal_date);
//     dataToSubmit.append('catogary', formData.catogary);
//     dataToSubmit.append('rank', formData.rank);
//     if (formData.photo && typeof formData.photo === 'object') {
//       dataToSubmit.append('photo', formData.photo);
//     }
//     if (formData.link) {
//       dataToSubmit.append('link', formData.link);
//     }

//     const request = isEditMode
//       ? api.patch(`${API_BASE_URL}/home-notification/legal-team/${selectedMember.id}/`, dataToSubmit, { headers: { 'Content-Type': 'multipart/form-data' } })
//       : api.post(`${API_BASE_URL}/home-notification/legal-team/`, dataToSubmit, { headers: { 'Content-Type': 'multipart/form-data' } });

//     request
//       .then(() => {
//         setSnackbarMessage(isEditMode ? 'Team member updated successfully.' : 'Team member added successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchLegalTeam(categoryFilter);
//       })
//       .catch((error) => {
//         console.error(isEditMode ? 'Update failed:' : 'Add failed:', error);
//         setSnackbarMessage(isEditMode ? 'Failed to update team member.' : 'Failed to add team member.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setOpenFormDialog(false);
//         setSubmitting(false);
//       });
//   };

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195,234,203,0.1)" p={2}>
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Admin Legal Team
//         </Typography>
//         <FormControl sx={{ minWidth: 180 }}>
//           <InputLabel id="category-filter-label">Category Filter</InputLabel>
//           <Select
//             labelId="category-filter-label"
//             value={categoryFilter}
//             label="Category Filter"
//             onChange={handleCategoryChange}
//             size="small"
//             disabled={submitting}
//           >
//             {categories.map((cat) => (
//               <MenuItem key={cat} value={cat}>
//                 {cat}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         <Button variant="contained" color="primary" onClick={handleAddMember} disabled={submitting}>
//           Add Member
//         </Button>
//       </Box>

//       {loading ? (
//         <LoadingSpinner size={30} />
//       ) : (
//         <TableComponent
//           columns={columns}
//           rows={rows}
//           manageColumnStatus
//           enableSort
//           sx={{
//             '& .MuiDataGrid-columnHeaders': {
//               backgroundColor: '#1976d2',
//               color: '#fff',
//               fontWeight: 'bold',
//             },
//           }}
//         />
//       )}

//       <Dialog open={openFormDialog} onClose={() => !submitting && setOpenFormDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>{isEditMode ? 'Edit Legal Team Member' : 'Add Legal Team Member'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Name"
//             fullWidth
//             value={formData.name}
//             error={!!formErrors.name}
//             helperText={formErrors.name}
//             onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//             disabled={submitting}
//           />
//           <TextField
//             margin="dense"
//             label="Designation"
//             fullWidth
//             value={formData.designation}
//             error={!!formErrors.designation}
//             helperText={formErrors.designation}
//             onChange={(e) => setFormData({ ...formData, designation: e.target.value })}
//             disabled={submitting}
//           />
//           <TextField
//             margin="dense"
//             label="Qualification"
//             fullWidth
//             value={formData.qualification}
//             error={!!formErrors.qualification}
//             helperText={formErrors.qualification}
//             onChange={(e) => setFormData({ ...formData, qualification: e.target.value })}
//             disabled={submitting}
//           />
//           <TextField
//             margin="dense"
//             label="Roles & Responsibility"
//             fullWidth
//             value={formData.roles_and_responsibility}
//             error={!!formErrors.roles_and_responsibility}
//             helperText={formErrors.roles_and_responsibility}
//             onChange={(e) => setFormData({ ...formData, roles_and_responsibility: e.target.value })}
//             disabled={submitting}
//           />
//           <TextField
//             margin="dense"
//             label="Appointment Date"
//             type="date"
//             fullWidth
//             value={formData.appointment_date}
//             error={!!formErrors.appointment_date}
//             helperText={formErrors.appointment_date}
//             onChange={(e) => setFormData({ ...formData, appointment_date: e.target.value })}
//             InputLabelProps={{ shrink: true }}
//             disabled={submitting}
//           />
//           <TextField
//             margin="dense"
//             label="Renewal Date"
//             type="date"
//             fullWidth
//             value={formData.renewal_date}
//             error={!!formErrors.renewal_date}
//             helperText={formErrors.renewal_date}
//             onChange={(e) => setFormData({ ...formData, renewal_date: e.target.value })}
//             InputLabelProps={{ shrink: true }}
//             disabled={submitting}
//           />
//           <TextField
//             margin="dense"
//             label="Category"
//             fullWidth
//             value={formData.catogary}
//             error={!!formErrors.catogary}
//             helperText={formErrors.catogary}
//             onChange={(e) => setFormData({ ...formData, catogary: e.target.value })}
//             disabled={submitting}
//           />
//           <TextField
//             margin="dense"
//             label="Rank"
//             type="number"
//             fullWidth
//             value={formData.rank}
//             error={!!formErrors.rank}
//             helperText={formErrors.rank}
//             onChange={(e) => setFormData({ ...formData, rank: Number(e.target.value) })}
//             disabled={submitting}
//           />

//           <input
//             accept="image/*"
//             style={{ marginTop: 16, marginBottom: 8 }}
//             id="photo-upload"
//             type="file"
//             onChange={handleFileChange}
//             disabled={submitting}
//           />
//           {formErrors.photo && <Typography color="error" variant="body2">{formErrors.photo}</Typography>}

//           {isEditMode && formData.photo && typeof formData.photo === 'string' && (
//             <img src={formData.photo} alt="Current" style={{ width: 80, height: 80, borderRadius: '50%', marginTop: 8 }} />
//           )}
//           {formData.photo && typeof formData.photo === 'object' && (
//             <img src={URL.createObjectURL(formData.photo)} alt="Preview" style={{ width: 80, height: 80, borderRadius: '50%', marginTop: 8 }} />
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenFormDialog(false)} disabled={submitting}>
//             Cancel
//           </Button>
//           <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={submitting}>
//             {submitting ? <CircularProgress size={24} color="inherit" /> : isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this team member?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={submitting}>
//             Cancel
//           </Button>
//           <Button onClick={handleDelete} variant="contained" color="error" disabled={submitting}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  CircularProgress, Select, MenuItem, FormControl, InputLabel,
} from '@mui/material';
import { Delete, Edit, Description } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../config';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import api from '../../api/axiosInterceptor';
import axios from 'axios';

export const AdminLegalTeamComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState(['All']);
  const [categoryFilter, setCategoryFilter] = useState('All');

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    designation: '',
    qualification: '',
    roles_and_responsibility: '',
    appointment_date: '',
    renewal_date: '',
    catogary: '',
    rank: 0,
    photo: null,
    link: null,
  });

  const [formErrors, setFormErrors] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteMember, setDeleteMember] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'name', field: 'name', headerName: 'Name', width: 150 },
    { id: 'designation', field: 'designation', headerName: 'Designation', width: 150 },
    { id: 'qualification', field: 'qualification', headerName: 'Qualification', width: 150 },
    { id: 'roles', field: 'roles', headerName: 'Roles & Responsibility', width: 250 },
    {
      id: 'appointment_date',
      field: 'appointment_date',
      headerName: 'Appointment Date',
      width: 150,
      renderCell: (params) => (params.value ? new Date(params.value).toLocaleDateString() : ''),
    },
    {
      id: 'renewal_date',
      field: 'renewal_date',
      headerName: 'Renewal Date',
      width: 150,
      renderCell: (params) => (params.value ? new Date(params.value).toLocaleDateString() : ''),
    },
    { id: 'catogary', field: 'catogary', headerName: 'Category', width: 150 },
    { id: 'rank', field: 'rank', headerName: 'Rank', width: 90 },
    {
      id: 'photo',
      field: 'photo',
      headerName: 'Photo',
      width: 100,
      renderCell: (params) =>
        params.value ? (
          <img 
            src={params.value} 
            alt="team" 
            style={{ 
              width: '50px', 
              height: '50px', 
              borderRadius: '50%',
              objectFit: 'cover'
            }} 
          />
        ) : (
          'N/A'
        ),
    },
    {
      id: 'appointment_letter',
      field: 'link',
      headerName: 'Appointment Letter',
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <IconButton 
            color="primary" 
            href={params.value} 
            target="_blank"
            size="small"
            title="View Appointment Letter"
          >
            <Description />
          </IconButton>
        ) : (
          'N/A'
        ),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={submitting}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={submitting}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchLegalTeam(categoryFilter);
  }, [categoryFilter]);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/home-notification/legal-team/`);
      const uniqueCategories = Array.from(
        new Set(response.data.map((item) => item.catogary).filter((cat) => !!cat))
      );
      setCategories(['All', ...uniqueCategories]);
    } catch (error) {
      console.error('Failed to fetch categories:', error);
      setSnackbarMessage('Failed to load categories.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setCategories(['All']);
    }
  };

  const fetchLegalTeam = (category) => {
    setLoading(true);
    let url = `${API_BASE_URL}/home-notification/legal-team/`;
    if (category && category !== 'All') {
      url += `?catogary=${encodeURIComponent(category)}`;
    }
    axios
      .get(url)
      .then((response) => {
        const data = response.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          name: item.name,
          designation: item.designation,
          qualification: item.qualification,
          roles: item.roles_and_responsibility,
          appointment_date: item.appointment_date,
          renewal_date: item.renewal_date,
          catogary: item.catogary,
          rank: item.rank,
          photo: item.photo,
          link: item.link,
        }));
        setRows(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch legal team data:', error);
        setSnackbarMessage('Failed to load legal team data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleCategoryChange = (event) => {
    setCategoryFilter(event.target.value);
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddMember = () => {
    setIsEditMode(false);
    setFormData({
      name: '',
      designation: '',
      qualification: '',
      roles_and_responsibility: '',
      appointment_date: '',
      renewal_date: '',
      catogary: '',
      rank: 0,
      photo: null,
      link: null,
    });
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleEdit = (member) => {
    setIsEditMode(true);
    setSelectedMember(member);
    setFormData({
      name: member.name,
      designation: member.designation,
      qualification: member.qualification || '',
      roles_and_responsibility: member.roles || '',
      appointment_date: member.appointment_date ? member.appointment_date.split('T')[0] : '',
      renewal_date: member.renewal_date ? member.renewal_date.split('T')[0] : '',
      catogary: member.catogary || '',
      rank: member.rank || 0,
      photo: null,
      link: null,
    });
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (member) => {
    setDeleteMember(member);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    if (!deleteMember) return;
    api
      .delete(`/home-notification/legal-team/${deleteMember.id}/`)
      .then(() => {
        setSnackbarMessage('Team member deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchLegalTeam(categoryFilter);
      })
      .catch((error) => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete team member.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteMember(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name?.trim()) errors.name = 'Name is required';
    if (!formData.designation?.trim()) errors.designation = 'Designation is required';
    
    if (formData.rank === '' || isNaN(formData.rank) || formData.rank < 0) {
      errors.rank = 'Rank must be a valid number (0 or greater)';
    }
    
    if (formData.photo && typeof formData.photo === 'object' && formData.photo.size > 2 * 1024 * 1024) {
      errors.photo = 'Photo must be less than 2 MB';
    }
    
    if (formData.link && typeof formData.link === 'object' && formData.link.size > 2 * 1024 * 1024) {
      errors.link = 'Appointment letter must be less than 2 MB';
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, photo: file });
      setFormErrors({ ...formErrors, photo: '' });
    }
  };

  const handleAppointmentLetterChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, link: file });
      setFormErrors({ ...formErrors, link: '' });
    }
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) return;
    
    setSubmitting(true);
    const dataToSubmit = new FormData();
    
    dataToSubmit.append('name', formData.name.trim());
    dataToSubmit.append('designation', formData.designation.trim());
    
    if (formData.qualification?.trim()) {
      dataToSubmit.append('qualification', formData.qualification.trim());
    }
    if (formData.roles_and_responsibility?.trim()) {
      dataToSubmit.append('roles_and_responsibility', formData.roles_and_responsibility.trim());
    }
    if (formData.appointment_date) {
      dataToSubmit.append('appointment_date', formData.appointment_date);
    }
    if (formData.renewal_date) {
      dataToSubmit.append('renewal_date', formData.renewal_date);
    }
    if (formData.catogary?.trim()) {
      dataToSubmit.append('catogary', formData.catogary.trim());
    }
    dataToSubmit.append('rank', formData.rank.toString());

    if (formData.photo && typeof formData.photo === 'object') {
      dataToSubmit.append('photo', formData.photo);
    }
    if (formData.link && typeof formData.link === 'object') {
      dataToSubmit.append('link', formData.link);
    }

    try {
      const request = isEditMode
        ? api.patch(`/home-notification/legal-team/${selectedMember.id}/`, dataToSubmit, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
        : api.post(`/home-notification/legal-team/`, dataToSubmit, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });

      await request;
      setSnackbarMessage(isEditMode ? 'Team member updated successfully.' : 'Team member added successfully.');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchLegalTeam(categoryFilter);
    } catch (error) {
      console.error(isEditMode ? 'Update failed:' : 'Add failed:', error);
      setSnackbarMessage(isEditMode ? 'Failed to update team member.' : 'Failed to add team member.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setOpenFormDialog(false);
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: 'rgba(195,234,203,0.1)', p: 2 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Admin Legal Team
        </Typography>
        <FormControl sx={{ minWidth: 180 }}>
          <InputLabel id="category-filter-label">Category Filter</InputLabel>
          <Select
            labelId="category-filter-label"
            value={categoryFilter}
            label="Category Filter"
            onChange={handleCategoryChange}
            size="small"
            disabled={submitting}
          >
            {categories.map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button variant="contained" color="primary" onClick={handleAddMember} disabled={submitting}>
          Add Member
        </Button>
      </Box>

      {loading ? (
        <LoadingSpinner size={30} />
      ) : (
        <TableComponent
          columns={columns}
          rows={rows}
          manageColumnStatus
          enableSort
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#1976d2',
              color: '#fff',
              fontWeight: 'bold',
            },
          }}
        />
      )}

      <Dialog open={openFormDialog} onClose={() => !submitting && setOpenFormDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>{isEditMode ? 'Edit Legal Team Member' : 'Add Legal Team Member'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Name *"
            fullWidth
            value={formData.name}
            error={!!formErrors.name}
            helperText={formErrors.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            disabled={submitting}
          />
          <TextField
            margin="dense"
            label="Designation *"
            fullWidth
            value={formData.designation}
            error={!!formErrors.designation}
            helperText={formErrors.designation}
            onChange={(e) => setFormData({ ...formData, designation: e.target.value })}
            disabled={submitting}
          />
          <TextField
            margin="dense"
            label="Qualification (Optional)"
            fullWidth
            value={formData.qualification}
            onChange={(e) => setFormData({ ...formData, qualification: e.target.value })}
            disabled={submitting}
          />
          <TextField
            margin="dense"
            label="Roles & Responsibility (Optional)"
            fullWidth
            multiline
            rows={3}
            value={formData.roles_and_responsibility}
            onChange={(e) => setFormData({ ...formData, roles_and_responsibility: e.target.value })}
            disabled={submitting}
          />
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <TextField
              margin="dense"
              label="Appointment Date (Optional)"
              type="date"
              sx={{ flex: 1 }}
              value={formData.appointment_date}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setFormData({ ...formData, appointment_date: e.target.value })}
              disabled={submitting}
            />
            <TextField
              margin="dense"
              label="Renewal Date (Optional)"
              type="date"
              sx={{ flex: 1 }}
              value={formData.renewal_date}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setFormData({ ...formData, renewal_date: e.target.value })}
              disabled={submitting}
            />
          </Box>
          <TextField
            margin="dense"
            label="Category (Optional)"
            fullWidth
            value={formData.catogary}
            onChange={(e) => setFormData({ ...formData, catogary: e.target.value })}
            disabled={submitting}
          />
          <TextField
            margin="dense"
            label="Rank"
            type="number"
            fullWidth
            value={formData.rank}
            error={!!formErrors.rank}
            helperText={formErrors.rank}
            inputProps={{ min: 0 }}
            onChange={(e) => setFormData({ ...formData, rank: Number(e.target.value) || 0 })}
            disabled={submitting}
          />

          {/* Photo Upload */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle2" gutterBottom>Photo (Optional, &lt; 2MB)</Typography>
            <input
              accept="image/*"
              style={{ marginTop: '8px', width: '100%' }}
              id="photo-upload"
              type="file"
              onChange={handlePhotoChange}
              disabled={submitting}
            />
            {formErrors.photo && (
              <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                {formErrors.photo}
              </Typography>
            )}
            {formData.photo && typeof formData.photo === 'object' && (
              <img
                src={URL.createObjectURL(formData.photo)}
                alt="Preview"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  marginTop: '8px',
                  objectFit: 'cover'
                }}
              />
            )}
          </Box>

          {/* Appointment Letter Upload */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle2" gutterBottom>Appointment Letter (Optional, &lt; 2MB)</Typography>
            <input
              accept=".pdf,.doc,.docx"
              style={{ marginTop: '8px', width: '100%' }}
              id="appointment-letter-upload"
              type="file"
              onChange={handleAppointmentLetterChange}
              disabled={submitting}
            />
            {formErrors.link && (
              <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                {formErrors.link}
              </Typography>
            )}
            {formData.link && typeof formData.link === 'object' && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Selected: {formData.link.name} ({(formData.link.size / 1024 / 1024).toFixed(2)} MB)
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFormDialog(false)} disabled={submitting}>
            Cancel
          </Button>
          <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={submitting}>
            {submitting ? <CircularProgress size={24} color="inherit" /> : (isEditMode ? 'Update' : 'Add')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this team member?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={submitting}>
            Cancel
          </Button>
          <Button onClick={handleDelete} variant="contained" color="error" disabled={submitting}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
